<!-- ============================================================== -->
<!-- footer 2  -->
<!-- ============================================================== -->
<div class="footer2 font-14 bg-dark">
  <div class="f2-topbar container">
    <div class="d-flex">
      <a href="#"><img src="../../assets/images/sizeassetcopierwhite.png" alt="wrapkit" style="width: 250px; height: 65px" /></a>
      <div class="ml-auto align-self-center">
        <span class="text-white">Assetstore by AssetX</span> © 2020 Tutti i diritti riservati.
      </div>
    </div>
  </div>
  <div class="f2-middle">
    <div class="container">
      <div class="row">
        <!-- Column -->
        <div class="col-lg-4 col-md-6">
          <p class="p-t-10">Piattaforma realizzata per la gestione account AssetStore e presentazione del servizio</p>
          <p>Per ogni informazione o problema non esitare a contattarci tramite i nostri recapiti o tramite il form dedicato.</p>
          <div class="m-t-20 m-b-30">
            <a (click)="redirect('https://www.facebook.com/pg/Assetcopier-363384977786102/videos/?ref=page_internal')" class="link"><i class="icon-Facebook-2"></i></a>
            <a class="link"><i class="icon-Twitter "></i></a>
            <a class="link"><i class="icon-Linkedin-2"></i></a>
            <a (click)="redirect('https://www.instagram.com/assetx_trading_systems/?hl=it')" class="link"><i class="icon-Instagram "></i></a>
          </div>
        </div>
        <!-- Column -->
        <div class="col-lg-2 col-md-6">
          <ul class="general-listing">
            <li><a href="/home"><i class="fa fa-circle"></i> Home</a></li>
            <li><a href="/store"><i class="fa fa-circle"></i> Store</a></li>
            <li><a href="/come funziona"><i class="fa fa-circle"></i> Come Funziona</a></li>
            <li><a href="/chi siamo"><i class="fa fa-circle"></i> Chi Siamo</a></li>
            <li><a href="/partners"><i class="fa fa-circle"></i> Partners</a></li>
            <li><a href="/affiliate program"><i class="fa fa-circle"></i> Affiliate Program </a></li>
            <li><a href="/contattaci"><i class="fa fa-circle"></i> Contattaci </a></li>
          </ul>
        </div>
        <!-- Column -->
        <!-- Column -->
        <div class="col-lg-3 col-md-6 info-box">
          <div class="d-flex no-block">
            <div class="display-7 m-r-20 align-self-top"><i class="icon-Location-2"></i></div>
            <div class="info">
              <p>Conegliano , TV
                <br/> Italia - 31015<br>P.IVA 05060750261</p>
            </div>
          </div>
          <div class="d-flex no-block">
            <div class="display-7 m-r-20 align-self-top"><i class="icon-Over-Time"></i></div>
            <div class="info">
              <span class="font-medium text-muted db  m-t-5">9.00 - 21:00</span>
            </div>
          </div>
          <div class="d-flex no-block">
            <div class="display-7 m-r-20 align-self-top"><i class="icon-Phone-2"></i></div>
            <div class="info">
              <span class="font-medium text-muted db  m-t-5">+39 351 700 2031</span>
            </div>
          </div>
          <div class="d-flex no-block">
            <div class="display-7 m-r-20 align-self-top"><i class="icon-Mail"></i></div>
            <div class="info">
              <a href="#" class="font-medium text-muted db  m-t-5">info@assetcopier.com</a>
            </div>
          </div>
        </div>
        <!-- Column -->
        <!-- Column -->
        <div class="col-lg-3 col-md-6">
          <div class="subscribe-box">
            <div class="display-4 text-white"><i class="icon-Mail-3"></i></div>
            <p>Scrivici per ogni informazione, risponderemo al più presto </p>
            <form>
              <button class="btn btn-info-gradiant" (click)="redirect('/contattaci')">Contattaci</button>
            </form>
          </div>
          <br>
          <a href="../../assets/privacy.pdf" target="_blank">Privacy policy</a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- ============================================================== -->
<!-- End footer 2  -->
<!-- ============================================================== -->
